import { useRef, useEffect, useState } from "react"
import Layout from '../../Layout'
import ProductGroupAccordion from '../../components/Products/ProductGroupAccordion'
import ManufacturerAccordion from '../../components/Products/ManufacturerAccordion'
import ProductTagList from '../../components/Products/ProductTagList'
import ProductsList from "components/Products/ProductsList"
import RecommendationList from "components/Products/RecommendationList"
import FilterMobileDialog from "components/Products/FilterMobileDialog"

const SORT_OPTIONS = [
    "Bán chạy nhất",
    "Giá thấp đến cao",
    "Giá cao đến thấp",
    "Hàng mới nhất",
]

export default function Dashboard() {

    const listRef = useRef<HTMLDivElement>(null)

    const [canScrollLeft, setCanScrollLeft] = useState(false)
    const [canScrollRight, setCanScrollRight] = useState(true)
    const [checked, setChecked] = useState(false)

    const [open, setOpen] = useState(false)
    const [value, setValue] = useState("Bán chạy nhất")
    const wrapperRef = useRef<HTMLDivElement | null>(null)
    const [showFilter, setShowFilter] = useState(false)

    useEffect(() => {
        if (showFilter) {
            document.documentElement.style.overflow = "hidden"
            document.documentElement.style.height = "100%"

            document.body.style.overflow = "hidden"
            document.body.style.height = "100%"
            document.body.style.touchAction = "none"
        } else {
            document.documentElement.style.overflow = ""
            document.documentElement.style.height = ""

            document.body.style.overflow = ""
            document.body.style.height = ""
            document.body.style.touchAction = ""
        }

        return () => {
            document.documentElement.style.overflow = ""
            document.documentElement.style.height = ""
            document.body.style.overflow = ""
            document.body.style.height = ""
            document.body.style.touchAction = ""
        }
    }, [showFilter])

    const SCROLL_DISTANCE = 320

    const updateScrollState = () => {
        const el = listRef.current
        if (!el) return

        const { scrollLeft, scrollWidth, clientWidth } = el

        setCanScrollLeft(scrollLeft > 0)
        setCanScrollRight(scrollLeft + clientWidth < scrollWidth - 1)
    }

    const scrollLeft = () => {
        listRef.current?.scrollBy({
            left: -SCROLL_DISTANCE,
            behavior: "smooth",
        })
    }

    const scrollRight = () => {
        listRef.current?.scrollBy({
            left: SCROLL_DISTANCE,
            behavior: "smooth",
        })
    }

    useEffect(() => {
        updateScrollState()
    }, [])

    const toggle = (e: React.MouseEvent) => {
        e.preventDefault() // 👈 QUAN TRỌNG
        setChecked((prev) => !prev)
    }

    const [page, setPage] = useState(1)
    const totalPage = 5

    const goPrev = () => {
        if (page > 1) setPage(page - 1)
    }

    const goNext = () => {
        if (page < totalPage) setPage(page + 1)
    }

    useEffect(() => {
        const handlePointerDown = (e: PointerEvent) => {
            if (
                wrapperRef.current &&
                !wrapperRef.current.contains(e.target as Node)
            ) {
                setOpen(false)
            }
        }

        // 👇 capture = true → ăn trước mọi stopPropagation
        document.addEventListener("pointerdown", handlePointerDown, true)

        return () => {
            document.removeEventListener("pointerdown", handlePointerDown, true)
        }
    }, [])

    return (
        <Layout>
            <div className="style_container__eyX8n">
                <div className="style_wrapperBreadCrumb__5V8CJ">
                    <nav
                        className="MuiTypography-root MuiBreadcrumbs-root MuiTypography-body1 MuiTypography-colorTextSecondary"
                        aria-label="breadcrumb"
                    >
                        <ol className="MuiBreadcrumbs-ol">
                            <li className="MuiBreadcrumbs-li">
                                <a className="styles_item_breadcrumb__eYGFd" href="/">
                                    Trang chủ
                                </a>
                            </li>

                            <li
                                aria-hidden="true"
                                className="MuiBreadcrumbs-separator"
                                ins-init-condition="#Lk11aUJyZWFkY3J1bWJzLW9sIGxpOm5vdCg6Zmlyc3Qp"
                            >
                                <svg
                                    className="MuiSvgIcon-root MuiSvgIcon-fontSizeSmall"
                                    focusable="false"
                                    viewBox="0 0 24 24"
                                    aria-hidden="true"
                                >
                                    <path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z" />
                                </svg>
                            </li>

                            <li
                                className="MuiBreadcrumbs-li"
                                ins-init-condition="#Lk11aUJyZWFkY3J1bWJzLW9sIGxpOm5vdCg6Zmlyc3Qp"
                            >
                                <span className="styles_item_breadcrumb__eYGFd styles_last_breadcrumb__c7IQm">
                                    Sản phẩm
                                </span>
                            </li>
                        </ol>
                    </nav>
                </div>

                <div className="mb-4 hidden-1199">
                    <div className="styles_wrapper__7piYE">
                        {/* SCROLL LEFT */}
                        {canScrollLeft && (
                            <button
                                className="styles_scrollButton__9ompJ"
                                aria-label="Scroll left"
                                onClick={scrollLeft}
                            >
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                                    <circle
                                        cx="12"
                                        cy="12"
                                        r="12"
                                        transform="matrix(-1 0 0 1 24 0)"
                                        fill="#C1C8D1"
                                    />
                                    <path
                                        fillRule="evenodd"
                                        clipRule="evenodd"
                                        d="M14.8561 6.25105C15.1908 6.58579 15.1908 7.1285 14.8561 7.46323L10.3193 12L14.8561 16.5368C15.1908 16.8715 15.1908 17.4142 14.8561 17.7489C14.5214 18.0837 13.9786 18.0837 13.6439 17.7489L8.50105 12.6061C8.16632 12.2714 8.16632 11.7286 8.50105 11.3939L13.6439 6.25105C13.9786 5.91632 14.5214 5.91632 14.8561 6.25105Z"
                                        fill="white"
                                    />
                                </svg>
                            </button>
                        )}

                        {/* LIST */}
                        <div className="styles_containerList__EB2bE scrollbar-0" onScroll={updateScrollState} ref={listRef}>
                            {/* ========== ITEM 1 ========== */}
                            <div>
                                <a
                                    className="styles_mobile_rootBase__8z7PQ styles_item__cI8YZ styles_activeItem__UI9iD"
                                    href="https://thuocsi.vn/products"
                                >
                                    <div className="styles_wrapperContent__KcVAH">
                                        <div className="styles_iconWrapper__xq2Nj">
                                            <span
                                                style={{
                                                    boxSizing: "border-box",
                                                    display: "inline-block",
                                                    overflow: "hidden",
                                                    width: "initial",
                                                    height: "initial",
                                                    background: "none",
                                                    opacity: 1,
                                                    border: "0px",
                                                    margin: "0px",
                                                    padding: "0px",
                                                    position: "relative",
                                                    maxWidth: "100%"
                                                }}
                                            >
                                                <span style={{ boxSizing: "border-box", display: "block", width: "initial", height: "initial", background: "none", opacity: 1, border: "0px", margin: "0px", padding: "0px", maxWidth: "100%" }}>
                                                    <img alt="" aria-hidden="true" src="data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24'/%3e"
                                                        style={{
                                                            display: "block", maxWidth: "100%", width: "initial", height: "initial", background: "none", opacity: 1, border: "0px", margin: "0px", padding: "0px"
                                                        }}
                                                    />
                                                </span>
                                                <img
                                                    alt="Tất Cả Sản Phẩm"
                                                    src="https://gcs.buymed.com/thuocsi-live/internal/cms/20250ce46c2ec9f3b298dbe5d04932b0tatcasanpham_active.svg"
                                                    style={{
                                                        position: "absolute",
                                                        inset: "0px",
                                                        boxSizing: "border-box",
                                                        padding: "0px",
                                                        border: "none",
                                                        margin: "auto",
                                                        display: "block",
                                                        width: "0px",
                                                        height: "0px",
                                                        minWidth: "100%",
                                                        maxWidth: "100%",
                                                        minHeight: "100%",
                                                        maxHeight: "100%"
                                                    }}
                                                />
                                            </span>
                                        </div>
                                        <span>Tất Cả Sản Phẩm</span>
                                    </div>
                                </a>
                            </div>

                            {/* ========== ITEM 2 ========== */}
                            <div>
                                <a className="styles_mobile_rootBase__8z7PQ styles_item__cI8YZ" href="https://thuocsi.vn/products?tag=32U1">
                                    <div className="styles_wrapperContent__KcVAH">
                                        <div className="styles_iconWrapper__xq2Nj">
                                            <img alt="Thuốc Kê Đơn" src="https://gcs.buymed.com/thuocsi-live/internal/cms/2025c361d66b458e3399de762467f460thuockedon_inactive.svg" />
                                        </div>
                                        <span>Thuốc Kê Đơn</span>
                                    </div>
                                </a>
                            </div>

                            {/* ========== ITEM 3 ========== */}
                            <div>
                                <a className="styles_mobile_rootBase__8z7PQ styles_item__cI8YZ" href="https://thuocsi.vn/products?tag=A4DX">
                                    <div className="styles_wrapperContent__KcVAH">
                                        <div className="styles_iconWrapper__xq2Nj">
                                            <img alt="Thuốc Không Kê Đơn" src="https://gcs.buymed.com/thuocsi-live/internal/cms/202509d02932b0119233d9d68f71b0a6thuockhongkedon.svg" />
                                        </div>
                                        <span>Thuốc Không Kê Đơn</span>
                                    </div>
                                </a>
                            </div>

                            {/* ========== ITEM 4 ========== */}
                            <div>
                                <a className="styles_mobile_rootBase__8z7PQ styles_item__cI8YZ" href="https://thuocsi.vn/products?tag=VDCL">
                                    <div className="styles_wrapperContent__KcVAH">
                                        <div className="styles_iconWrapper__xq2Nj">
                                            <img alt="Thực Phẩm Chức Năng" src="https://gcs.buymed.com/thuocsi-live/internal/cms/20259a3998af0979ca2af9fd37125b7athucphamchucnang.svg" />
                                        </div>
                                        <span>Thực Phẩm Chức Năng</span>
                                    </div>
                                </a>
                            </div>

                            {/* ========== ITEM 5 ========== */}
                            <div>
                                <a className="styles_mobile_rootBase__8z7PQ styles_item__cI8YZ" href="https://thuocsi.vn/products?tag=XGQD">
                                    <div className="styles_wrapperContent__KcVAH">
                                        <div className="styles_iconWrapper__xq2Nj">
                                            <img alt="Dược Mỹ Phẩm" src="https://gcs.buymed.com/thuocsi-live/internal/cms/2025c9d40edfb19bb493454ee4ab9031duocmypham.svg" />
                                        </div>
                                        <span>Dược Mỹ Phẩm</span>
                                    </div>
                                </a>
                            </div>

                            {/* ========== ITEM 6 ========== */}
                            <div>
                                <a className="styles_mobile_rootBase__8z7PQ styles_item__cI8YZ" href="https://thuocsi.vn/products?tag=B70T">
                                    <div className="styles_wrapperContent__KcVAH">
                                        <div className="styles_iconWrapper__xq2Nj">
                                            <img alt="Thiết Bị & Vật Tư Y Tế" src="https://gcs.buymed.com/thuocsi-live/internal/cms/2025e4051fe2b60fc999657422ff565ethietbiyte.svg" />
                                        </div>
                                        <span>Thiết Bị & Vật Tư Y Tế</span>
                                    </div>
                                </a>
                            </div>

                            {/* ========== ITEM 7 ========== */}
                            <div>
                                <a className="styles_mobile_rootBase__8z7PQ styles_item__cI8YZ" href="https://thuocsi.vn/products?tag=C81Y">
                                    <div className="styles_wrapperContent__KcVAH">
                                        <div className="styles_iconWrapper__xq2Nj">
                                            <img alt="Hàng Tiêu Dùng" src="https://gcs.buymed.com/thuocsi-live/internal/cms/2025a2b56fe9c25066c7cd158fe11847hangtieudung.svg" />
                                        </div>
                                        <span>Hàng Tiêu Dùng</span>
                                    </div>
                                </a>
                            </div>

                            {/* ========== ITEM 8 ========== */}
                            <div>
                                <a className="styles_mobile_rootBase__8z7PQ styles_item__cI8YZ" href="https://thuocsi.vn/products?tag=BMSE">
                                    <div className="styles_wrapperContent__KcVAH">
                                        <div className="styles_iconWrapper__xq2Nj">
                                            <img alt="Buymed Tuyển Chọn" src="https://gcs.buymed.com/thuocsi-live/internal/cms/202549462c469e209ee3256e88faf1fdbuymedtuyenchon.svg" />
                                        </div>
                                        <span>Buymed Tuyển Chọn</span>
                                    </div>
                                </a>
                            </div>

                            {/* ========== ITEM 9 ========== */}
                            <div>
                                <a className="styles_mobile_rootBase__8z7PQ styles_item__cI8YZ" href="https://thuocsi.vn/products?tag=ECLT&currentTab=combo-uu-dai&page=1">
                                    <div className="styles_wrapperContent__KcVAH">
                                        <div className="styles_iconWrapper__xq2Nj">
                                            <img alt="Combo Ưu Đãi" src="https://cdn-gcs.thuocsi.vn/thuocsi-live/internal/cms/2025dd5b281edd5a06d03c046ab11fb2combouudai.svg" />
                                        </div>
                                        <span>Combo Ưu Đãi</span>
                                    </div>
                                </a>
                            </div>
                        </div>
                        {/* SCROLL RIGHT */}
                        {canScrollRight && (
                            <button
                                className="styles_scrollButton__9ompJ"
                                aria-label="Scroll right"
                                onClick={scrollRight}
                            >
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                                    <circle cx="12" cy="12" r="12" fill="#C1C8D1" />
                                    <path
                                        d="M16.1264 11.1743L11.0402 6.33027C10.8103 6.11009 10.523 6 10.1782 6C9.85249 6 9.57471 6.11009 9.34483 6.33027C9.11494 6.55046 9 6.81651 9 7.12844C9 7.44037 9.11494 7.70642 9.34483 7.92661L13.5977 12L9.34483 16.0459C9.11494 16.2661 9 16.5413 9 16.8716C9 17.1835 9.11494 17.4495 9.34483 17.6697C9.57471 17.8899 9.85249 18 10.1782 18C10.523 18 10.8103 17.8899 11.0402 17.6697L16.1264 12.8257C16.3755 12.6055 16.5 12.3303 16.5 12C16.5 11.6697 16.3755 11.3945 16.1264 11.1743Z"
                                        fill="white"
                                    />
                                </svg>
                            </button>
                        )}
                    </div>
                </div>

                <div className="style_wrapper__bwV9H">
                    <div className="style_sidebar__l2b5C hidden-1199">
                        <div className="style_group__V1E_g">
                            <div>
                                <div className="styles_containerFilter___rtUq">
                                    <ProductGroupAccordion />
                                </div>
                            </div>
                            <hr className="style_hr__fnI3e" />
                            <div className="mt-4">
                                <div className="styles_containerFilter___rtUq">
                                    <ManufacturerAccordion />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="style_product_main__USHVn">
                        <div className="style_filterMobile__4vy1x show-1199 relative z-10">
                            <div className="style_filterSortRow__4D2kS">
                                <div className="style_filterButton__6xPq4" onClick={() => setShowFilter(true)}>
                                    <svg
                                        width="16"
                                        height="16"
                                        viewBox="0 0 16 16"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            d="M3.33333 14L3.33333 9.33333M3.33333 9.33333C4.06971 9.33333 4.66667 8.73638 4.66667 8C4.66667 7.26362 4.06971 6.66667 3.33333 6.66667M3.33333 9.33333C2.59695 9.33333 2 8.73638 2 8C2 7.26362 2.59695 6.66667 3.33333 6.66667M8 14V8M8 3.33333V2M8 3.33333C8.73638 3.33333 9.33333 3.93029 9.33333 4.66667C9.33333 5.40305 8.73638 6 8 6C7.26362 6 6.66667 5.40305 6.66667 4.66667C6.66667 3.93029 7.26362 3.33333 8 3.33333ZM3.33333 6.66667L3.33333 2M12.6667 8V2M12.6667 14V12.6667M12.6667 12.6667C13.403 12.6667 14 12.0697 14 11.3333C14 10.597 13.403 10 12.6667 10C11.9303 10 11.3333 10.597 11.3333 11.3333C11.3333 12.0697 11.9303 12.6667 12.6667 12.6667Z"
                                            stroke="#005c29"
                                            strokeLinecap="round"
                                        />
                                    </svg>

                                    <span className="style_btnText__DXTjV">Bộ lọc</span>
                                </div>

                                <div className="style_select__rqefc" ref={wrapperRef}>
                                    <span className="style_headSort__VGBNI">Sắp xếp</span>

                                    <div style={{ position: "relative" }}>
                                        <button
                                            className={
                                                "MuiButtonBase-root style_customButtonSelect__iI282" +
                                                (open ? " Mui-expanded" : "")
                                            }
                                            tabIndex={0}
                                            type="button"
                                            aria-controls="customized-menu"
                                            aria-haspopup="true"
                                            aria-expanded={open}
                                            onClick={(e) => {
                                                e.stopPropagation()
                                                setOpen((v) => !v)
                                            }}
                                        >
                                            Bán chạy nhất

                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="24"
                                                height="24"
                                                viewBox="0 0 24 24"
                                                fill="none"
                                            >
                                                <path
                                                    d="M7.85795 13.2706C7.09014 13.2706 6.70624 14.3152 7.26465 14.9178L11.4178 19.6987C11.7319 20.1004 12.2554 20.1004 12.6044 19.6987L16.7575 14.9178C17.281 14.3152 16.8971 13.2706 16.1642 13.2706H7.85795ZM16.7575 9.05212L12.6044 4.27119C12.2554 3.9096 11.7319 3.9096 11.4178 4.27119L7.26465 9.05212C6.70624 9.69494 7.09014 10.6993 7.85795 10.6993H16.1642C16.8971 10.6993 17.281 9.69494 16.7575 9.05212Z"
                                                    fill="#1F1F1F"
                                                />
                                            </svg>

                                            <span className="MuiTouchRipple-root" />
                                        </button>

                                        {/* DROPDOWN */}
                                        {open && (
                                            <div className="MuiMenu-paper right-0 top-[110%] MuiPaper-root absolute MuiPaper-elevation0 MuiPaper-rounded min-w-[160px]">
                                                <ul className="jss275 MuiMenu-list MuiList-root MuiMenu-list jss274 MuiList-padding flex flex-col bg-white" role="menu" aria-labelledby="customized-menu">
                                                    {SORT_OPTIONS.map((item) => (
                                                        <li
                                                            key={item}
                                                            className={
                                                                "MuiButtonBase-root MuiListItem-root MuiMenuItem-root jss297 MuiMenuItem-gutters MuiListItem-gutters MuiListItem-button" +
                                                                (value === item ? " Mui-selected" : "")
                                                            }
                                                            onClick={() => {
                                                                setValue(item)
                                                                setOpen(false)
                                                            }}
                                                        >
                                                            {item}
                                                        </li>
                                                    ))}
                                                </ul>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="style_wrapperListTag__O7hG5">
                            <ProductTagList />
                        </div>
                        <div className="style_product_grid_wrapper__lYnBj">
                            <div className="style_sort___U0J9">
                                <div className="style_hiddenContainer__3MwzR">
                                    <div className="MuiGrid-root MuiGrid-container MuiGrid-item MuiGrid-grid-xs-12">
                                        <div className="MuiBox-root css-1dtnjt5">
                                            <label
                                                className="MuiFormControlLabel-root sc-5bd16284-0 cuEQuH style_textHidden__kn0HQ flex items-center" onClick={toggle}
                                            >
                                                <span
                                                    className={
                                                        "MuiButtonBase-root MuiIconButton-root jss8 MuiCheckbox-root MuiCheckbox-colorSecondary MuiIconButton-colorSecondary" +
                                                        (checked ? " Mui-checked" : "")
                                                    }
                                                    aria-disabled="false"
                                                >
                                                    <span className="MuiIconButton-label">
                                                        <input
                                                            className="jss11"
                                                            name="filter-out-of-stock"
                                                            type="checkbox"
                                                            data-indeterminate="false"
                                                            value=""
                                                        />
                                                        {checked ?
                                                            <svg className="MuiSvgIcon-root" focusable="false" viewBox="0 0 24 24" aria-hidden="true"><path d="M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"></path></svg>
                                                            :
                                                            <svg className="MuiSvgIcon-root" focusable="false" viewBox="0 0 24 24" aria-hidden="true"><path d="M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"></path></svg>
                                                        }
                                                    </span>

                                                    <span className="MuiTouchRipple-root" />
                                                </span>

                                                <span className="MuiTypography-root MuiFormControlLabel-label MuiTypography-body1 !leading-[1.5] !m-0 !p-0 !h-[39px] !flex !items-center whitespace-nowrap">
                                                    {checked ? "Đã Ẩn Sản Phẩm Hết Hàng" : "Ẩn Sản Phẩm Hết Hàng"}
                                                </span>
                                            </label>
                                        </div>
                                    </div>
                                </div>

                                <div className="style_topPagging__fUaNu">
                                    <div className="styles_pagiContainer__B0imj MuiBox-root css-1vwfmvr">
                                        <nav
                                            aria-label="pagination navigation"
                                            className="MuiPagination-root jss273"
                                        >
                                            <ul className="MuiPagination-ul">
                                                {/* PREV */}
                                                <li>
                                                    <button
                                                        className={
                                                            "MuiButtonBase-root MuiPaginationItem-root MuiPaginationItem-page" +
                                                            (page === 1 ? " Mui-disabled" : "")
                                                        }
                                                        tabIndex={page === 1 ? -1 : 0}
                                                        type="button"
                                                        disabled={page === 1}
                                                        aria-label="Go to previous page"
                                                        onClick={goPrev}
                                                    >
                                                        <svg
                                                            className="MuiSvgIcon-root MuiPaginationItem-icon"
                                                            focusable="false"
                                                            viewBox="0 0 24 24"
                                                            aria-hidden="true"
                                                        >
                                                            <path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z" />
                                                        </svg>
                                                    </button>
                                                </li>

                                                {/* PAGE NUMBERS */}
                                                {Array.from({ length: totalPage }).map((_, i) => {
                                                    const p = i + 1
                                                    return (
                                                        <li key={p}>
                                                            <button
                                                                className={
                                                                    "MuiButtonBase-root MuiPaginationItem-root MuiPaginationItem-page" +
                                                                    (page === p ? " Mui-selected" : "")
                                                                }
                                                                tabIndex={0}
                                                                type="button"
                                                                aria-current={page === p ? "true" : undefined}
                                                                aria-label={`Go to page ${p}`}
                                                                onClick={() => setPage(p)}
                                                            >
                                                                {p}
                                                                <span className="MuiTouchRipple-root" />
                                                            </button>
                                                        </li>
                                                    )
                                                })}

                                                {/* ELLIPSIS */}
                                                <li>
                                                    <div className="MuiPaginationItem-root MuiPaginationItem-ellipsis">
                                                        …
                                                    </div>
                                                </li>

                                                {/* NEXT */}
                                                <li>
                                                    <button
                                                        className="MuiButtonBase-root MuiPaginationItem-root MuiPaginationItem-page"
                                                        tabIndex={0}
                                                        type="button"
                                                        aria-label="Go to next page"
                                                        onClick={goNext}
                                                    >
                                                        <svg
                                                            className="MuiSvgIcon-root MuiPaginationItem-icon"
                                                            focusable="false"
                                                            viewBox="0 0 24 24"
                                                            aria-hidden="true"
                                                        >
                                                            <path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z" />
                                                        </svg>
                                                        <span className="MuiTouchRipple-root" />
                                                    </button>
                                                </li>
                                            </ul>
                                        </nav>
                                    </div>
                                </div>

                                <div className="style_select__rqefc hidden-1199" ref={wrapperRef}>
                                    <span className="style_headSort__VGBNI">Sắp xếp</span>

                                    <div style={{ position: "relative" }}>
                                        <button
                                            className={
                                                "MuiButtonBase-root style_customButtonSelect__iI282" +
                                                (open ? " Mui-expanded" : "")
                                            }
                                            tabIndex={0}
                                            type="button"
                                            aria-controls="customized-menu"
                                            aria-haspopup="true"
                                            aria-expanded={open}
                                            onClick={(e) => {
                                                e.stopPropagation()
                                                setOpen((v) => !v)
                                            }}
                                        >
                                            Bán chạy nhất

                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="24"
                                                height="24"
                                                viewBox="0 0 24 24"
                                                fill="none"
                                            >
                                                <path
                                                    d="M7.85795 13.2706C7.09014 13.2706 6.70624 14.3152 7.26465 14.9178L11.4178 19.6987C11.7319 20.1004 12.2554 20.1004 12.6044 19.6987L16.7575 14.9178C17.281 14.3152 16.8971 13.2706 16.1642 13.2706H7.85795ZM16.7575 9.05212L12.6044 4.27119C12.2554 3.9096 11.7319 3.9096 11.4178 4.27119L7.26465 9.05212C6.70624 9.69494 7.09014 10.6993 7.85795 10.6993H16.1642C16.8971 10.6993 17.281 9.69494 16.7575 9.05212Z"
                                                    fill="#1F1F1F"
                                                />
                                            </svg>

                                            <span className="MuiTouchRipple-root" />
                                        </button>

                                        {/* DROPDOWN */}
                                        {open && (
                                            <div className="MuiMenu-paper right-0 top-[110%] MuiPaper-root absolute MuiPaper-elevation0 MuiPaper-rounded min-w-[160px]">
                                                <ul className="jss275 MuiMenu-list MuiList-root MuiMenu-list jss274 MuiList-padding flex flex-col" role="menu" aria-labelledby="customized-menu">
                                                    {SORT_OPTIONS.map((item) => (
                                                        <li
                                                            key={item}
                                                            className={
                                                                "MuiButtonBase-root MuiListItem-root MuiMenuItem-root jss297 MuiMenuItem-gutters MuiListItem-gutters MuiListItem-button" +
                                                                (value === item ? " Mui-selected" : "")
                                                            }
                                                            onClick={() => {
                                                                setValue(item)
                                                                setOpen(false)
                                                            }}
                                                        >
                                                            {item}
                                                        </li>
                                                    ))}
                                                </ul>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div style={{ margin: "8px 0px", fontStyle: "italic", color: "rgb(245, 34, 45)" }}>*Giá bạn đang xem là giá đã giảm sau khi áp dụng các chương trình khuyến mãi như chiết khấu chuyển khoản và mã giảm giá</div>
                        <ProductsList />
                        <div className="style_bottomPagging__kzl7h">
                            <div className="styles_pagiContainer__B0imj MuiBox-root css-1vwfmvr">
                                <nav
                                    aria-label="pagination navigation"
                                    className="MuiPagination-root jss273"
                                >
                                    <ul className="MuiPagination-ul">
                                        {/* PREV */}
                                        <li>
                                            <button
                                                className={
                                                    "MuiButtonBase-root MuiPaginationItem-root MuiPaginationItem-page" +
                                                    (page === 1 ? " Mui-disabled" : "")
                                                }
                                                tabIndex={page === 1 ? -1 : 0}
                                                type="button"
                                                disabled={page === 1}
                                                aria-label="Go to previous page"
                                                onClick={goPrev}
                                            >
                                                <svg
                                                    className="MuiSvgIcon-root MuiPaginationItem-icon"
                                                    focusable="false"
                                                    viewBox="0 0 24 24"
                                                    aria-hidden="true"
                                                >
                                                    <path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z" />
                                                </svg>
                                            </button>
                                        </li>

                                        {/* PAGE NUMBERS */}
                                        {Array.from({ length: totalPage }).map((_, i) => {
                                            const p = i + 1
                                            return (
                                                <li key={p}>
                                                    <button
                                                        className={
                                                            "MuiButtonBase-root MuiPaginationItem-root MuiPaginationItem-page" +
                                                            (page === p ? " Mui-selected" : "")
                                                        }
                                                        tabIndex={0}
                                                        type="button"
                                                        aria-current={page === p ? "true" : undefined}
                                                        aria-label={`Go to page ${p}`}
                                                        onClick={() => setPage(p)}
                                                    >
                                                        {p}
                                                        <span className="MuiTouchRipple-root" />
                                                    </button>
                                                </li>
                                            )
                                        })}

                                        {/* ELLIPSIS */}
                                        <li>
                                            <div className="MuiPaginationItem-root MuiPaginationItem-ellipsis">
                                                …
                                            </div>
                                        </li>

                                        {/* NEXT */}
                                        <li>
                                            <button
                                                className="MuiButtonBase-root MuiPaginationItem-root MuiPaginationItem-page"
                                                tabIndex={0}
                                                type="button"
                                                aria-label="Go to next page"
                                                onClick={goNext}
                                            >
                                                <svg
                                                    className="MuiSvgIcon-root MuiPaginationItem-icon"
                                                    focusable="false"
                                                    viewBox="0 0 24 24"
                                                    aria-hidden="true"
                                                >
                                                    <path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z" />
                                                </svg>
                                                <span className="MuiTouchRipple-root" />
                                            </button>
                                        </li>
                                    </ul>
                                </nav>
                            </div>
                        </div>
                    </div>
                </div>

                <RecommendationList />
            </div>
            <FilterMobileDialog open={showFilter} onClose={() => setShowFilter(false)} />
        </Layout>
    )
}
